import type { TitleUnitResponse } from "@/types/titleUnit";
import { useId, useState } from "react";
import type { CmsMedia } from "@/types/strapi";
import useResizeListener from "../../../hooks/useResizeListener";
import { CmsImage } from "@/components/common/CmsImage";
import * as React from "react";

const TitleUnit = ({
    titleUnit,
}: {
    titleUnit: TitleUnitResponse | undefined;
}) => {
    const desktopImage = titleUnit?.data?.attributes?.offerListImageDesktop;
    const mobileImage = titleUnit?.data?.attributes?.offerListImageMobile;

    const desktopImageMinWidth =
        titleUnit?.data?.attributes?.offerListImageDesktopMinWidth;

    const defaultImage = mobileImage || desktopImage || null;

    // This is used to change between desktop and mobile images.
    // Not all title units use this feature. If they just have a single "image"
    // use that instead.
    const [imageToUse, setImageToUse] = useState<CmsMedia | null>(defaultImage);
    const imageId = useId();

    const hasImage = Boolean(mobileImage?.data || desktopImage?.data);

    useResizeListener(() => {
        if (desktopImage && mobileImage && desktopImageMinWidth) {
            const imageContainer = document.getElementById(imageId);
            if (imageContainer) {
                if (imageContainer.offsetWidth >= desktopImageMinWidth) {
                    setImageToUse(desktopImage);
                } else {
                    setImageToUse(mobileImage);
                }
            }
        }
    });

    return (
        <div id={imageId}>
            {hasImage ? (
                <CmsImage
                    cmsMedia={imageToUse}
                    defaultAlt={"title unit"}
                    responsive={true}
                />
            ) : null}
        </div>
    );
};

export default TitleUnit;
